// extracted by mini-css-extract-plugin
export default {"img-servicios":"ServiciosOfrecidos_img-servicios__OVylM","contenedor-componente-servicios":"ServiciosOfrecidos_contenedor-componente-servicios__txo3j"};